import { render, staticRenderFns } from "./OwnerInformationTree.vue?vue&type=template&id=06a6ef88&scoped=true&"
import script from "./OwnerInformationTree.vue?vue&type=script&lang=js&"
export * from "./OwnerInformationTree.vue?vue&type=script&lang=js&"
import style0 from "./OwnerInformationTree.vue?vue&type=style&index=0&id=06a6ef88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a6ef88",
  null
  
)

export default component.exports